import { useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';

import { CircularProgress, Stack } from '@mui/material';

const StudioAuthorizationCallback = () => {
  const [searchParams] = useSearchParams();
  const authorizationCode = searchParams.get('code');
  const state = searchParams.get('state');

  useEffect(() => {
    if (!authorizationCode || !state || !window.opener) {
      return;
    }

    window.opener.postMessage(
      { type: 'AUTH_COMPLETED', authorizationCode, state },
      window.location.origin,
    );
    window.close();
  }, [authorizationCode, state]);

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{ minWidth: '100vw', minHeight: '100vh' }}
    >
      <CircularProgress />
    </Stack>
  );
};
export default StudioAuthorizationCallback;
